















































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import CopiedToClipboard from '@/components/miniComponents/CopiedToClipboard.vue'

const partyRoomModule = namespace('partyRoom')
const userModule = namespace('user')

interface MenuItem {
  title: string;
  link: string;
}

@Component({
  components: { CopiedToClipboard }
})
export default class PartyMenu extends Vue {
  @partyRoomModule.Getter('partyName') partyName!: string
  @partyRoomModule.Getter('partyID') partyID!: string
  @userModule.Getter('displayName') displayName!: string

  showMenu = false
  showPopup = false

  menuItems: Array<MenuItem> = [
    {
      title: 'Settings',
      link: `/${this.partyID}`
    },
    {
      title: 'Leave party',
      link: '/'
    }
  ]

  fallbackCopyTextToClipboard (text: string) {
    const textArea = document.createElement('textarea')
    textArea.value = text

    // Avoid scrolling to bottom
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      const msg = successful ? 'successful' : 'unsuccessful'
      console.log('Fallback: Copying text command was ' + msg)
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea)
  }

  copyTextToClipboard (text: string) {
    return new Promise((resolve, reject) => {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text)
        return resolve(true)
      }
      navigator.clipboard.writeText(text).then(function () {
        resolve(true)
      }, function (err) {
        reject(err)
      })
    })
  }

  async copyLink () {
    await this.copyTextToClipboard(window.location.href)
    this.showPopup = true
    setTimeout(() => { this.showPopup = false }, 2000)
  }
}
